import axios from 'axios';
import { call, put } from 'redux-saga/effects';
import { creators } from '../actions.js';

function fetchJson(_ref) {
  var payload = _ref.payload;
  return function* () {
    var url = payload === null || payload === void 0 ? void 0 : payload.url;
    try {
      if (!url) {
        throw new Error('markdown url must be provided');
      }
      var response = yield call(axios, {
        method: 'get',
        timeout: 5000,
        url: url
      });
      if (!response || !response.data) {
        throw new Error('response object not returned from axios');
      }
      var json = response.data;
      yield put(yield call(creators.fetchJsonSuccess, {
        payload: {
          url: url,
          json: json
        }
      }));
    } catch (error) {
      yield put(yield call(creators.fetchJsonError, {
        payload: {
          url: typeof url === 'undefined' ? null : url
        },
        error: error.message
      }));
    }
  }();
}

export { fetchJson as default };
//# sourceMappingURL=fetchJson.js.map
